<template>
    <v-container class="py-5 px-5" fluid v-if="this.$store.state.signedIn">
        <v-form ref="form" v-model="valid" lazy-validation>
                    <v-layout justify-center>
                        <v-flex xs12 class="px-2 py-2">
                            <v-toolbar dark flat color="secondary">
                                <v-toolbar-title :style="$store.state.textFormatting.headers">
                                    Raw data download
                                </v-toolbar-title>
                                <v-spacer />
                                <info>
                                    <template slot>
                                       Download Raw Data
                                    </template>
                                    <template slot="body">
                                        <p> All data ingested by the system is stored for access by users of BGP Spotlight. We have multiple sources of data:
                                        </p>
                                         <ul>
                                             <li >RouteViews (University of Oregon Project). See http://www.routeviews.org/routeviews/</li>
                                             <li >RIPE RIS Live. See https://ris-live.ripe.net/</li>
                                             <li >CSP Data ingest (BT, KCOM, GAMMA, TalkTalk)</li>
                                         </ul>
                                        <br>
                                        <p>
                                            Select a time range to run the search for, then select which collectors you'd like to run the search for. 
                                            Finally, select an ASN to search the raw data for. This will search the AS path in messages, and will return if the ASN is found anywhere in the path.
                                        </p>
                                        <p> 
                                            When a search is run for multiple collectors, the system will create multiple jobs and these will then return a separate download link for each. 
                                            Similarly, when you cancel / delete a job, it will cancel all other jobs created under the same job order.
                                        </p>
                                        <p>
                                            Each job will go through 4 status, as follows:
                                            <ul>
                                                <li> <b>Gathering raw data</b>: Pulling all messages for the timeframe from the given collector </li>
                                                <li> <b>Processing</b>: Filtering out messages of interest (i.e. for the ASN searched for) </li>
                                                <li> <b>Storing result</b>: Storing the results in S3 ready for user to access </li>
                                                <li> <b>Complete</b>: Ready for retrieval </li>
                                            </ul>
                                            The job may also be displayed as 'Cancelled' / 'Cancelling' where the user has deleted the job from the table.

                                        </p>
                                    </template>
                                </info>
                            </v-toolbar>
                            <v-card>
                                <v-card-text>
                                    <v-layout wrap>
                                        <v-flex xs12 md4 class="px-2 py-2">
                                            <v-layout>
                                                <v-flex xs12 md6 class="px-2">
                                                    <v-card>
                                                        <v-card-text>
                                                            <h3 :style="$store.state.textFormatting.main"> Time From </h3>
                                                            <v-layout>
                                                                <v-flex xs12 md6>
                                                                    <v-select :style="$store.state.textFormatting.main" v-model="timeFrom.hour" :rules="rules" :items="hourItems" label="Hour" required> </v-select>
                                                                </v-flex >
                                                                <v-flex xs12 md6>
                                                                    <v-select :style="$store.state.textFormatting.main" v-model="timeFrom.minute" :rules="rules" :items="minItems" label="Minutes" required> </v-select>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-card v-if="time_from_adj" color="success">
                                                                <v-card-text>
                                                                    <h3> {{ time_from_adj }} </h3>
                                                                </v-card-text>
                                                            </v-card>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs12 md6 class="px-2">
                                                    <v-card>
                                                        <v-card-text>
                                                            <h3 :style="$store.state.textFormatting.main"> Time To</h3>
                                                            <v-layout>
                                                                <v-flex xs12 md6>
                                                                    <v-select :style="$store.state.textFormatting.main" v-model="timeTo.hour" :items="hourItems" :rules="rules"  label="Hour" required> </v-select>
                                                                </v-flex>
                                                                <v-flex xs12 md6>
                                                                    <v-select :style="$store.state.textFormatting.main" v-model="timeTo.minute" :items="minItems" :rules="rules" label="Minutes" required> </v-select>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-card v-if="time_to_adj" color="success">
                                                                <v-card-text>
                                                                    <h3> {{ time_to_adj }} </h3>
                                                                </v-card-text>
                                                            </v-card>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                               
                                        </v-flex>
                                        <v-flex xs12 md4 class="px-2 py-2">
                                            <v-card>
                                                <v-card-text>
                                                    <h3 :style="$store.state.textFormatting.main"> Date </h3>
                                                    <v-layout>
                                                        <v-flex xs12 md4>
                                                            <v-select :style="$store.state.textFormatting.main" v-model="date.day" :items="useFromDays" :rules="rules" label="Day" required> </v-select>
                                                        </v-flex>
                                                        <v-flex xs12 md4>
                                                            <v-select :style="$store.state.textFormatting.main" v-model="date.month" :items="useFromMonths" :rules="rules" item-text="name" item-value="number" label="Month" @change="updateFromDay" required> </v-select>
                                                        </v-flex>
                                                        <v-flex xs12 md4>
                                                            <v-select :style="$store.state.textFormatting.main" v-model="date.year" :items="YearItems" :rules="rules" label="Year" @change="updateFromMonth" required> </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>
                                        <v-flex  xs12 md4 class="px-2 py-2">
                                                        <v-layout justify-center align-center>
                                                            <v-flex xs12 class="px-2 py-2">
                                                                <v-text-field 
                                                                    v-model="input_asn" 
                                                                    label="ASN Input"
                                                                    :rules="asn_rules" 
                                                                    :style="$store.state.textFormatting.headers"
                                                                    >
                                                                </v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout justify-center align-center>
                                                            <v-flex xs12 class="px-2 py-2">
                                                                <v-text-field 
                                                                    v-model="input_prefix" 
                                                                    label="Prefix Input"
                                                                    :rules="prefix_rules"
                                                                    :style="$store.state.textFormatting.headers"
                                                                    >
                                                                </v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                        <v-flex xs7>
                                            <v-card>
                                                <v-layout>
                                                    <v-flex xs7>
                                                        <v-layout align-center justify-center>
                                                            <v-flex xs7 class="px-1 py-1">    
                                                                <v-btn color="secondary" dark @click="showCollectors=!showCollectors" :style="$store.state.textFormatting.main">
                                                                    Select Collectors
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex xs5 class="px-1 py-1">
                                                                <v-btn v-if="collector_selected.length==collector_selection.length" color="red" @click="deselectAll()" :style="$store.state.textFormatting.main"> Deselect All </v-btn>
                                                                <v-btn v-if="collector_selected.length!=collector_selection.length" color="success" @click="selectAll()" :style="$store.state.textFormatting.main"> Select All </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs5 class="px-1 py-1">
                                                        <v-card>
                                                            <v-progress-circular v-if="collector_loading" indeterminate color="secondary" > </v-progress-circular>
                                                            <v-card-text>
                                                                <div v-if="collector_selected.length > 0&&!collector_loading">
                                                                    <v-tooltip bottom eager color="primary">
                                                                        <template v-slot:activator="{ on }">
                                                                            <div v-on="on" :style="$store.state.textFormatting.main">
                                                                                <b :style="$store.state.textFormatting.main"> Selected Collectors: </b> 
                                                                                <span v-if="collector_selected.length == 0" :style="$store.state.textFormatting.main"> None (use 'Select Collectors')</span>{{ collector_selected.join(', ') }}
                                                                            </div>
                                                                        </template>
                                                                        <span> <b>NOTE:</b> This will create a separate job for each collector selected, i.e. {{ collector_selected.length }} jobs will be created.</span>
                                                                    </v-tooltip>        
                                                                </div>
                                                                <div v-if="collector_selected.length == 0&&!collector_loading" :style="$store.state.textFormatting.main">    
                                                                    <b :style="$store.state.textFormatting.main"> Selected Collectors: </b> 
                                                                    <span v-if="collector_selected.length == 0" :style="$store.state.textFormatting.main"> None (use 'Select Collectors')</span>{{ collector_selected.join(', ') }}
                                                                </div>
                                                                
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-flex>
                                                </v-layout>
                                                
                                            </v-card>
                                            <v-flex class="py-2">
                                                <v-card v-if="create_msg" :color="create_msg_col">
                                                    <v-card-text>
                                                        <h3 :style="$store.state.textFormatting.main"> {{ create_msg }} </h3>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>
                                        </v-flex>

                                    </v-layout>
                                    
                                    <v-layout>
                                        <div v-if="collector_selected.length == 0">
                                            <v-tooltip top color="primary">
                                                <template v-slot:activator="{ on }">
                                                    <div v-on="on">
                                                        <v-btn @click="download" color="success" :style="$store.state.textFormatting.main" :disabled="collector_selected.length == 0||create_loading"> SUBMIT </v-btn>
                                                    </div>
                                                </template>
                                                <span> Ensure you have selected collectors (see 'Select Collectors')</span>
                                            </v-tooltip>        
                                        </div>
                                        <div v-if="collector_selected.length > 0">    
                                            <v-btn @click="download" color="success" :style="$store.state.textFormatting.main" :disabled="collector_selected.length == 0||create_loading"> SUBMIT </v-btn>
                                        </div>
                                        <v-progress-circular v-if="create_loading" indeterminate color="secondary" > </v-progress-circular>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center>
                        <v-flex xs12 class="px-2 py-2">
                            <v-toolbar dark flat color="secondary">
                                <v-toolbar-title :style="$store.state.textFormatting.headers"> Current Jobs</v-toolbar-title>
                                <v-flex xs1 />
                                <v-tooltip top color="secondary">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" @click="getStatus()" fab small v-if="!loading" icon color="success">
                                            <v-icon :style="$store.state.textFormatting.headers"> refresh </v-icon>
                                        </v-btn>
                                    </template>
                                    <span :style="$store.state.textFormatting.main">Refresh</span>
                                </v-tooltip>
                                <v-spacer />
                                <!-- <v-btn v-if="showUrls" @click="downloadAll()" color="success"> Download all </v-btn> !-->
                            </v-toolbar>
                            
                            <v-card>
                                <v-progress-circular v-if="loading" indeterminate color="secondary" > </v-progress-circular>
                                <v-data-table
                                    :headers="headersURL" 
                                    :items="current_jobs"
                                    :rows-per-page-items="rowsPerPageItems" 
                                    :pagination.sync="pagination" 
                                    :search="search"
                                    v-if="!loading">
                                    <template slot="headerCell" slot-scope="props">
                                        <v-tooltip top eager>
                                        <span slot="activator" :style="$store.state.textFormatting.main">
                                            {{ props.header.text }}
                                        </span>
                                        <span :style="$store.state.textFormatting.main">
                                            {{ props.header.ad_text }}
                                        </span>
                                        </v-tooltip>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <tr >
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center">
                                                <div v-if="props.item.header" @click="alternateDetails(props.item.rdd_jobid)">
                                                    <div v-if="search=='JOB'"><v-icon class="cursor-pointer" color="success">add</v-icon></div>
                                                    <div v-if="search!='JOB'"><v-icon class="cursor-pointer" >remove</v-icon></div>
                                                </div>
                                            </td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center d-none" :style="$store.state.textFormatting.main"> {{ props.item.rdd_header }}</td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.rdd_collector }}</td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.rdd_prefix }}</td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.rdd_path }}</td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.rdd_recordcount }}</td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.time_from }}</td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.time_to }}</td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.time_init }}</td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.rdd_status }}</td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center" :style="$store.state.textFormatting.main"> <div v-if="props.item.rdd_progress">{{ props.item.rdd_progress }}%</div></td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center" :style="$store.state.textFormatting.main"> 
                                                <v-btn v-if="props.item.rdd_download_ready==1"
                                                    color="success"
                                                    :style="$store.state.textFormatting.main"
                                                    @click="preDownload(props.item)" > Download </v-btn> 
                                                <div v-if="props.item.rdd_download_ready==0">Not Ready</div>
                                                <div v-if="props.item.rdd_download_ready==9"> - </div>
                                            </td>
                                            <td :class="{ 'header-row' : props.item.header }" class="text-xs-center" :style="$store.state.textFormatting.main"> 
                                                <v-icon v-if="props.item.actions==1" class="mr-2" @click="preCancelJob(props.item)"> close </v-icon> 
                                                <v-icon v-if="props.item.actions==9" class="mr-2" @click="preDeleteJob(props.item)"> delete </v-icon> 
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-alert :value="true" color="red" icon="warning" :style="$store.state.textFormatting.main">
                                            No active jobs, add one using the above selectors. Don't forget to choose collectors using 'Select Collectors'
                                        </v-alert>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <v-dialog v-model="show_pre_download" width="500">
                        <v-toolbar color="secondary" dark v-if="show_pre_download">
                            <v-toolbar-title> Download  </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                        </v-toolbar>
                        <v-card >
                            <v-card-text>
                                <h3 :style="$store.state.textFormatting.main"> Download for {{ pre_download.rdd_collector }}</h3>
                                <v-btn v-on:click="show_pre_download=false" v-if="pre_download_goturl" :href="pre_download.rdd_download_url" color="success"
                                    :style="$store.state.textFormatting.main"> Download </v-btn>
                                <div v-if="!pre_download_goturl"><v-progress-circular indeterminate color="secondary" > </v-progress-circular>Retrieving URL... Please wait...</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="red" dark @click="show_pre_download=false" :style="$store.state.textFormatting.main"> Close </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="show_pre_delete" width="500">
                        <v-toolbar color="secondary" dark v-if="show_pre_delete">
                            <v-toolbar-title> Delete job </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                        </v-toolbar>
                        <v-card >
                            <v-card-text>
                                <h3 v-if="pre_delete_job.header" :style="$store.state.textFormatting.main"> This will delete all jobs created for this job set</h3>
                                <h3 v-if="!pre_delete_job.header" :style="$store.state.textFormatting.main"> This will delete the job for {{ pre_delete_job.rdd_collector }}</h3>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn class="green" dark @click="deleteJob" :style="$store.state.textFormatting.main"> Yes, delete</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn class="red" dark @click="show_pre_delete=false" :style="$store.state.textFormatting.main"> No, close </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="show_pre_cancel" width="500">
                        <v-toolbar color="secondary" dark v-if="show_pre_cancel">
                            <v-toolbar-title> Cancel job </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                        </v-toolbar>
                        <v-card >
                            <v-card-text>
                                <h3 v-if="pre_cancel_job.header" :style="$store.state.textFormatting.main"> This will cancel all jobs created for this job set</h3>
                                <h3 v-if="!pre_cancel_job.header" :style="$store.state.textFormatting.main"> This will cancel the job for {{ pre_cancel_job.rdd_collector }}</h3>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn class="green" dark @click="cancelJob" :style="$store.state.textFormatting.main"> Yes, cancel</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn class="red" dark @click="show_pre_cancel=false" :style="$store.state.textFormatting.main"> No, close </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="showCollectors"  :width="$store.state.textFormatting.dialog.width">
                        <v-toolbar color="secondary" dark>
                            <v-toolbar-title :style="$store.state.textFormatting.headers"> Select collectors </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
                        </v-toolbar>
                        <v-card >
                            <v-layout wrap>
                                <v-flex class="px-3 py-3" xs4 v-for="collector in collector_selection" :key="collector.name">
                                    <v-card>
                                        <v-layout>
                                            <h2 :style="$store.state.textFormatting.headers">{{ collector.name }}</h2>
                                            <v-spacer />
                                            <v-flex xs2 class="text-xs-center">
                                                <v-checkbox v-model="collector.selected" />
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </v-flex>
                                <v-flex xs4 class="px-3 text-xs-center">
                                    <v-btn v-if="collector_selected.length==collector_selection.length" color="red" @click="deselectAll()" :style="$store.state.textFormatting.main"> Deselect All </v-btn>
                                    <v-btn v-if="collector_selected.length!=collector_selection.length" color="success" @click="selectAll()" :style="$store.state.textFormatting.main"> Select All </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-dialog>

        </v-form>
    </v-container>
</template>

<script>

import { API, graphqlOperation } from 'aws-amplify';
import info from "../../shared/operational/infopopout.vue";
import { findParentComponentByName } from '../../components/utils/findParent.js'
import { isValidPrefix, isValidAsn } from '../../shared/operational/validations';

const formatDate = (date_string) => {
    const d_from = new Date(date_string * 1000)
    const day = ("0" + d_from.getUTCDate()).slice(-2);
    const mon = ("0" + (d_from.getUTCMonth() + 1)).slice(-2);
    const yr = d_from.getUTCFullYear();
    const fdate = day + "/" + mon + "/" + yr;
    const timeFormatted = ("0" + d_from.getUTCHours()).slice(-2) + ":" + ("0" + d_from.getUTCMinutes()).slice(-2);
    return fdate + " " + timeFormatted;
}



export default {
    name: 'requestdata',
    components: {
        info
    },
    data () {
        return {
            search: 'JOB',
            hourItems:  ["00","01","02","03","04","05","06","07","08","09",10,11,12,13,14,15,16,17,18,19,20,21,22,23,24],
            minItems:  ["00", 15, 30, 45],
            dayItems: ["01","02","03","04","05","06","07","08","09",10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
            MonthItems: [{name: "January", number: "01"},
                        {name: "Feburary", number: "02"},
                        {name: "March", number: "03"},
                        {name: "April", number: "04"},
                        {name: "May", number: "05"},
                        {name: "June", number: "06"},
                        {name: "July", number: "07"},
                        {name: "August", number: "08"},
                        {name: "September", number: "09"},
                        {name: "October", number: "10"},
                        {name: "November", number: "11"},
                        {name: "December", number: "12"}],
            YearItems: [],
            timeTo: {"hour": "01", "minute": "00"},
            timeFrom: {"hour": "00", "minute" : "00"},
            date: {"day": "01", "month": "11", "year": 2019},
            rules: [v => !!v || "Value required"],
            data: [],
            name: [{name: "name"}],
            slider: 0,
            id: 0,
            monthDays: {
                "01": 31,
                "02": 28,
                "03": 31,
                "04": 30,
                "05": 31,
                "06": 30,
                "07": 31,
                "08": 31,
                "09": 30,
                "10": 31,
                "11": 30,
                "12": 31
            },
            showUrls: false,
            loading: false,
            useFromDays: [],
            useFromMonths: [],
            links: [],
            valid: false,
            downloadLinkData: false,
            headersURL: [
                { text: 'Expand', value:'header', align: 'center', ad_text: 'Expand or Shrink the Job Details', filterable:false},
                { text: 'header', value:'rdd_header', align: ' d-none'},
                { text: 'Collector', value:'rdd_collector', align:'centre', ad_text: 'Collector the query is running for',filterable: false},
                { text: 'Prefix searched', value:'rdd_prefix', align:'centre', ad_text: 'Prefix searched for in this query',filterable: false},
                { text: 'ASN Searched', value:'rdd_path', align:'centre', ad_text: 'ASN searched for in this query',filterable: false},
                { text: 'Records Found', value:'rdd_recordcount', align:'centre', ad_text: 'Number of BGP messages found for the query',filterable: false},
                { text: 'Time From', value:'time_from', align:'centre', ad_text: 'Time the query will run from (UTC)',filterable: false},
                { text: 'Time To', value:'time_to', align:'centre', ad_text: 'Time the query will run to (UTC)',filterable: false},
                { text: 'Time Initiated', value:'time_init', align:'centre', ad_text: 'Time this query was entered into the system (UTC)',filterable: false},
                { text: 'Current Status', value:'rdd_status', align:'centre', ad_text: 'Status in the system',filterable: false},
                { text: 'Progress', value:'rdd_progress', align:'centre', ad_text: 'Percentage complete of the \'Processing\' stage',filterable: false},
                { text: 'Download URL', value:'rdd_downloadurl', align:'centre', ad_text: 'URL to download the results',filterable: false},
                { text: 'Delete / Cancel', value:'none', align:'centre', ad_text: 'Remove the job from the queue. This will also delete all other jobs created in the same batch', sortable: false,filterable: false},
            ],
            rowsPerPageItems: [20, 30, 40, 50],
            pagination: {
                rowsPerPage: 10,
                sortBy: 'time_init',
                descending: true
            },
            pre_download: {
                rdd_downloadname: "aa",
                rdd_download_url: "bb"
            },
            pre_download_goturl: false,
            collector_selection: [],
            collector_selected: [],
            collector_loading: false,
            create_msg_col: 'success',
            create_msg: null,
            current_jobs: [],
            pre_delete_job: { header: false},
            pre_cancel_job: { header: false},
            job_count: null,
            show_pre_delete: false,
            show_pre_cancel: false,
            show_pre_download: false,
            time_to_adj: false,
            time_from_adj: false,
            asn_rules: [ v => v == "" || isValidAsn(v) ],
            prefix_rules: [ v => v == "" || isValidPrefix(v) ],
            input_asn: '',
            input_prefix: '',
            showCollectors: false,
            create_loading: false
        }
    },
    beforeMount () {

        let app = findParentComponentByName(this, 'app')
        app.checkSignedIn()

        if (this.$store.state.searches.rawASN) {
            this.input_asn = this.$store.state.searches.rawASN
        }

        this.getYears()

        this.getCollectorNames();
        this.getStatus();
    },
    mounted () {
        
    },
    methods: {
        setDefaultTimes: async function() {
            var date_obj1 = new Date()

            this.date.year = date_obj1.getUTCFullYear();
            
            var month_obj = date_obj1.getUTCMonth() + 1;
            var day_obj = date_obj1.getUTCDate();

            if (day_obj < 10) {
                this.date.day = "0" + String(day_obj)
            } else {
                this.date.day = day_obj
            }

            if (month_obj < 10) {
                this.date.month = "0" + String(month_obj)
            } else {
                this.date.month = String(month_obj)
            }

            
            
        },
        download: async function () {
            if (this.$refs.form.validate()) {
                this.createJob()
            }
        },
        getHeader: async function (h) {
            console.log(h)
            if (h===true) {
                console.log("hr")
                return("header-row")
            } else {
                console.log("nohr")
                return("")
            }
        },
        getCollectorNames: async function () {
            try {
                this.collector_loading = true;
                this.collector_selection = []
                var query = `
                    query getCollectorNames {
                        getCollectorNames {
                            name
                        }
                    }
                `;
                console.log(query)
                const res = await API.graphql(graphqlOperation(query));
                console.log(res);
                if (res) {
                    if (res.data.getCollectorNames) {
                        var collectorNames = res.data.getCollectorNames;
                        if (collectorNames) {
                            if (collectorNames.length > 0) {
                                for (var i = 0 ; i < collectorNames.length ; i++ ) {
                                    this.collector_selection.push({
                                        'name': collectorNames[i].name,
                                        'selected': false
                                    })
                                }
                                this.collector_selection.sort((a, b) => (a.name > b.name) ? 1 : -1)
                            }
                        }
                    }
                }
                this.collector_loading = false;
            } catch (err) {
                console.log(err)
                this.collector_loading = false;
            }

        },
        selectAll: async function () {
            this.collector_selected = []
            for (var i = 0 ; i < this.collector_selection.length ; i++ ) {
                this.collector_selection[i].selected = true
                this.collector_selected.push(this.collector_selection[i].name)
            }
        },
        deselectAll: async function () {
            this.collector_selected = []
            for (var i = 0 ; i < this.collector_selection.length ; i++ ) {
                this.collector_selection[i].selected = false
            }
        },
        adjustSelected: async function () {
            this.collector_selected = []
            for (var i = 0 ; i < this.collector_selection.length ; i++ ) {
                if (this.collector_selection[i].selected == true) {
                    this.collector_selected.push(this.collector_selection[i].name)
                }
            }
        },
        updateFromDay: async function () {
            this.useFromDays = [];
            var mon = this.date.month;
            var yr = this.date.year;
            var ndate = new Date();

            let nyear = ndate.getUTCFullYear();
            let nmonth = ("0" + (ndate.getUTCMonth() + 1)).slice(-2);
            let nday = ndate.getUTCDate();

            ndate.setDate(ndate.getUTCDate() - 184);
            let oyear = ndate.getUTCFullYear();
            let omonth = ("0" + (ndate.getUTCMonth() + 1)).slice(-2);
            let oday = ndate.getUTCDate();

            if (yr == nyear && mon == nmonth) {
                for(var i = 0 ; i < this.dayItems.length ; i++){
                    if(i < nday){
                        this.useFromDays.push(this.dayItems[i])
                    }
                }
            }

            if (yr == oyear && mon == omonth && omonth != nmonth) {
                for(var i = 0 ; i < this.dayItems.length ; i++){
                    if(i < this.monthDays[mon] && i >= oday){
                        this.useFromDays.push(this.dayItems[i])
                    }
                }
            }

            if ((yr >= oyear && yr <= nyear) && mon != omonth && omonth != nmonth && mon != nmonth) {
                for (var i = 0 ; i < this.dayItems.length ; i++) {
                    if(i < this.monthDays[mon]){
                        this.useFromDays.push(this.dayItems[i])
                    }
                }
            }
        },
        updateFromMonth: async function () {
            this.useFromMonths=[]
            var yr = this.date.year;
            var ndate = new Date();
            let nyear = ndate.getUTCFullYear();
            let nmonth = ndate.getUTCMonth();
            ndate.setDate(ndate.getUTCDate() - 184);
            let oyear = ndate.getUTCFullYear();
            let omonth = ndate.getUTCMonth();
            if (yr == nyear) {
                if ( omonth > nmonth ) {
                    for (var i = 0; i <= nmonth ; i++) {
                        this.useFromMonths.push(this.MonthItems[i]);
                    }
                } else {
                    for (var i = 0; i <= nmonth ; i++) {
                        if (i >= omonth) {
                            this.useFromMonths.push(this.MonthItems[i]);
                        }
                    }
                }
                
            }
            if (yr == oyear && nyear != oyear) {
                for (var i = omonth ; i <= 11 ; i++) {
                    this.useFromMonths.push(this.MonthItems[i]);
                }
            }
            this.updateFromDay();
            
        },
        getYears: async function () {
            var ndate = new Date();
            let nyear = ndate.getUTCFullYear();
            
            ndate.setDate(ndate.getUTCDate() - 184);
            let oyear = ndate.getUTCFullYear();
            this.YearItems = []
            while (nyear >= oyear) {
                console.log(String(nyear) + " ; " + String(oyear))
                this.YearItems.push(oyear);
                oyear++;
            }
            this.setDefaultTimes();
            this.updateFromMonth();
            
            
        },
        alternateDetails: async function (id) {
            if (this.search=="JOB") {
                this.search=id
            } else {
                this.search="JOB"
            }
            console.log(id)
        },
        getStatus: async function () {

            this.current_jobs = []
            this.loading = true
            var query = `
                query getRDDStatus {
                    getRDDStatus (
                        rdd_usertype: ""
                    ) {
                        error
                        status
                        command
                        errordesc
                        getResponse {
                            rdd_id
                            rdd_jobid
                            rdd_user
                            rdd_start
                            rdd_finish
                            rdd_prefix
                            rdd_path
                            rdd_collector
                            rdd_recordcount
                            rdd_status
                            rdd_progress
                            rdd_timeremaining
                            rdd_downloadname
                        }
                    }
                }
            `;
            const res = await API.graphql(graphqlOperation(query));
            console.log(res);
            var current_jobid=""
            var current_collector=""
            var local_current_jobs=res.data.getRDDStatus.getResponse;
            var job_header={
                rdd_header:true,
                rdd_id:"",
                rdd_jobid:"",
                rdd_user:"",
                rdd_start:"",
                rdd_finish:"",
                rdd_prefix:"",
                rdd_path:"",
                rdd_collector:"",
                rdd_recordcount:"",
                rdd_status:"",
                rdd_progress:"",
                rdd_timeremaining:"",
                rdd_downloadname:"",
                time_init:"",
                actions:0
            }
            var header_position=-1
            var sum_progress=0
            var sum_recordcount=0
            var sum_collector_count=0
            var running_state="Waiting"
            var sum_actions=0
            var job_actions=0
            var n=0
            var filterok=false
            if (res.data.getRDDStatus) {
                if (res.data.getRDDStatus.getResponse) {
//                    this.current_jobs = res.data.getRDDStatus.getResponse;
                    for (var i = 0 ; i < local_current_jobs.length ; i++ ) {
                        if (this.search.includes(local_current_jobs[i].rdd_jobid)) {
                            filterok=true
                        }
                        local_current_jobs[i].header=false
                        if (local_current_jobs[i].rdd_downloadname=="") {
                            local_current_jobs[i].rdd_download_ready=0
                        }
                        if (local_current_jobs[i].rdd_downloadname != null) {
                            if (local_current_jobs[i].rdd_downloadname.includes("zip")) {
                                local_current_jobs[i].rdd_download_ready=1
                            }
                        }
                        local_current_jobs[i].rdd_header = local_current_jobs[i].rdd_jobid
                        //convert possible null to 0
                        local_current_jobs[i].rdd_recordcount = local_current_jobs[i].rdd_recordcount || 0 
                        // format date
                        local_current_jobs[i].time_from = formatDate(local_current_jobs[i].rdd_start)
                        // format date
                        local_current_jobs[i].time_to = formatDate(local_current_jobs[i].rdd_finish)
                        // format date
                        var spl = local_current_jobs[i].rdd_jobid
                        local_current_jobs[i].time_init = spl.substring(6, 8) + "/" + spl.substring(4, 6) + "/" + spl.substring(0, 4) + " " + spl.substring(9, 11) + ":" + spl.substring(11, 13)

                        if (local_current_jobs[i].rdd_jobid!=current_jobid) {
                            console.log(i)
                            console.log(header_position)
                            if (header_position>=0) {
                                this.current_jobs[header_position].rdd_progress=Math.floor(sum_progress/sum_collector_count)
                                this.current_jobs[header_position].rdd_recordcount=sum_recordcount
                                this.current_jobs[header_position].rdd_status=running_state
                                this.current_jobs[header_position].rdd_collector=sum_collector_count.toString()+" Collectors"
                                if (["episodes","events","notifications"].indexOf(current_collector)>=0) {
                                    this.current_jobs[header_position].rdd_collector=current_collector;
                                }
                                this.current_jobs[header_position].header=true
                                if (running_state.includes("Waiting") || running_state.includes("Processing") || running_state.includes("Error")) {
                                    sum_actions=1 //cancel
                                } else {
                                    sum_actions=9 //delete
                                }
                                this.current_jobs[header_position].actions=sum_actions
                            }
                            current_collector=local_current_jobs[i].rdd_collector
                            current_jobid=local_current_jobs[i].rdd_jobid
                            console.log(current_jobid)
                            job_header.time_init = local_current_jobs[i].time_init
                            job_header.rdd_header="JOB "+current_jobid
                            job_header.rdd_collector=current_jobid
                            job_header.rdd_jobid=current_jobid
                            job_header.rdd_id=local_current_jobs[i].rdd_id
                            job_header.rdd_prefix=local_current_jobs[i].rdd_prefix
                            job_header.rdd_path=local_current_jobs[i].rdd_path
                            job_header.rdd_start=local_current_jobs[i].rdd_start
                            job_header.rdd_finish=local_current_jobs[i].rdd_finish
                            job_header.time_from=local_current_jobs[i].time_from
                            job_header.time_to=local_current_jobs[i].time_to
                            job_header.rdd_downloadname="-"
                            job_header.actions=0
                            job_header.rdd_download_ready=9
                            job_header.header=true
                            header_position=this.current_jobs.length
                            console.log(job_header)
                            this.current_jobs.push(Object.assign({},job_header))
                            sum_progress=0
                            sum_recordcount=0
                            sum_collector_count=0
                            running_state="Waiting"
                        }
                        if (local_current_jobs[i].rdd_collector!="Combined") {
                            console.log(local_current_jobs[i].rdd_collector)
                            console.log(local_current_jobs[i].rdd_recordcount)
                            sum_collector_count+=1
                            n=parseInt(local_current_jobs[i].rdd_recordcount)
                            if (!isNaN(n)) {
                                sum_recordcount+=n
                            }
                            n=parseInt(local_current_jobs[i].rdd_progress)
                            if (!isNaN(n)) {
                               sum_progress+=n
                            }
                        }

                        if (["Combined","episodes","events","notifications"].indexOf(local_current_jobs[i].rdd_collector)>=0) {
                            if (local_current_jobs[i].rdd_status=="Complete") {
                                console.log("Setting to complete")                            
                                running_state="Complete"
                                job_actions=9 //delete
                            } else if (local_current_jobs[i].rdd_status=="Cancelled") {
                                console.log("Setting to Cancelled")                            
                                running_state="Cancelled"
                                job_actions=9 //delete
                            } else {
                                job_actions=1
                            }
                        } else {
                            if (local_current_jobs[i].rdd_status!="Waiting.." && running_state!="Error") {
                                if (local_current_jobs[i].rdd_status=="Too big") {
                                    running_state="Error"
                                    job_actions=9 //cancel
                                } else {
                                    running_state="Processing"
                                    job_actions=1 //cancel
                                }
                            }
                            if (local_current_jobs[i].rdd_status=="Complete") {
                                job_actions=9 //delete
                            }
                        }
                        console.log("***** "+running_state)
                        local_current_jobs[i].actions=job_actions
                        console.log(local_current_jobs[i].rdd_jobid.toString()+"-"+local_current_jobs[i].rdd_collector.toString())
                        this.current_jobs.push(local_current_jobs[i])
                    }
                    if (header_position>=0) {
                        this.current_jobs[header_position].rdd_progress=Math.floor(sum_progress/sum_collector_count)
                        this.current_jobs[header_position].rdd_recordcount=sum_recordcount
                        this.current_jobs[header_position].rdd_status=running_state
                        this.current_jobs[header_position].rdd_collector=sum_collector_count.toString()+" Collectors"
                        if (["episodes","events","notifications"].indexOf(current_collector)>=0) {
                            this.current_jobs[header_position].rdd_collector=current_collector;
                        }
                        this.current_jobs[header_position].header=true
                        if (running_state.includes("Waiting") || running_state.includes("Processing") || running_state.includes("Error")) {
                            sum_actions=1 //cancel
                        } else {
                            sum_actions=9 //delete
                        }
                        this.current_jobs[header_position].actions=sum_actions
                    }
                    this.loading = false
                    console.log(this.current_jobs)
                } else {
                    this.loading = false
                }
            } else {
                this.loading = false
            }
            if (filterok===false) {
                this.search="JOB"
            }
            
        },
        preDownload: async function (job) {
            this.pre_download = job
            this.show_pre_download = true
            this.pre_download_goturl=false
            this.pre_download.rdd_download_url=""
            try {
                var query = `query getRDDdownloadurl {
                    getRDDdownloadurl(rdd_usertype:"user",
                    rdd_downloadname:"` + job.rdd_downloadname + `") {
                        error
                        status
                        command
                        errordesc
                        getResponse {
                            rdd_id
                            rdd_jobid
                            rdd_user
                            rdd_start
                            rdd_finish
                            rdd_prefix
                            rdd_path
                            rdd_collector
                            rdd_recordcount
                            rdd_status
                            rdd_progress
                            rdd_timeremaining
                            rdd_downloadname
                            rdd_downloadurl
                        }
                    }
                }`;
                console.log(query)
                const res = await API.graphql(graphqlOperation(query));
                console.log(res);
                var response=res.data.getRDDdownloadurl.getResponse;
                this.pre_download_goturl=true
                this.pre_download.rdd_download_url=response[0].rdd_downloadurl
                console.log(response)             


            } catch (err) {
                console.log(err)
            }
        },

        preDeleteJob: async function (job) {
            this.pre_delete_job = job
            var count = 0;
            for (var i = 0 ; i < this.current_jobs.length ; i++) {
                if (this.current_jobs[i].rdd_jobid == job.rdd_jobid && !job.header) {
                    count += 1
                }
                if ( i == this.current_jobs.length - 1) {
                    this.job_count = count
                    this.show_pre_delete = true
                }
            }
        },

        preCancelJob: async function (job) {
            this.pre_cancel_job = job
            var count = 0;
            for (var i = 0 ; i < this.current_jobs.length ; i++) {
                if (this.current_jobs[i].rdd_jobid == job.rdd_jobid && !job.header) {
                    count += 1
                }
                if ( i == this.current_jobs.length - 1) {
                    this.job_count = count
                    this.show_pre_cancel = true
                }
            }
        },

        deleteJob: async function () {
            var job = this.pre_delete_job
            var collector=job.rdd_collector
            if (job.header) {
                collector=""
                this.search="JOB"
            }
            try {
                var query = `mutation deleteJob {
                    deleteRDDJob(rdd_usertype:"user",
                    rdd_jobid:"` + job.rdd_jobid + `",
                    rdd_collector:"` + collector + `") {
                        status
                        error
                        errordesc
                        command
                        deleteResponse
                    }
                }`;
                console.log(query)
                const res = await API.graphql(graphqlOperation(query));
                console.log(res);
                this.show_pre_delete = false
                this.getStatus()
            } catch (err) {
                console.log(err)
            }
        },

        cancelJob: async function () {
            var job = this.pre_cancel_job
            var collector=job.rdd_collector
            if (job.header) {
                collector=""
                this.search="JOB"
            }
            try {
                var query = `mutation cancelPost {
                    cancelRDDJob(rdd_usertype:"user",
                    rdd_jobid:"` + job.rdd_jobid + `",
                    rdd_collector:"` + collector + `") {
                        status
                        error
                        errordesc
                        command
                        cancelResponse
                    }
                }`;
                console.log(query)
                const res = await API.graphql(graphqlOperation(query));
                console.log(res);
                this.show_pre_cancel = false
                this.getStatus()
            } catch (err) {
                console.log(err)
            }
        },



        createJob: async function () {
            //Format required 2019-04-11 03:45:00
            /* var d = new Date (epoch * 1000);
            var day = ("0" + d.getUTCDate).slice(-2);
            var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
            var year = d.getUTCFullYear() */

            this.time_to_adj = false
            this.time_from_adj = false
            
            var timeFrom = new Date(this.date.year + "-" + this.date.month + "-" + this.date.day + "T" + this.timeFrom.hour + ":" + this.timeFrom.minute + ":00Z").getTime() / 1000
            var timeTo = new Date(this.date.year + "-" + this.date.month + "-" + this.date.day + "T" + this.timeTo.hour + ":" + this.timeTo.minute + ":00Z").getTime() / 1000

            console.log(timeFrom)
            console.log(timeTo)
            console.log(JSON.stringify(this.collector_selected))

            this.create_loading = true;
            this.create_msg = null;

            var now = new Date()
            var timeNow = Math.floor(now.getTime() / 1000)

            console.log(now)
            console.log(timeNow)

            var filters = {
                "prefix":this.input_prefix, 
                "path":this.input_asn,
                "asn":this.input_asn
                }

            if (timeNow < timeTo) {
                timeTo = timeNow - 900 // take 15 minutes back from now as the last possible time it can be run
                var day = ("0" + now.getUTCDate()).slice(-2);
                var mon = ("0" + (now.getUTCMonth() + 1)).slice(-2);
                var yr = now.getUTCFullYear();
                var fdate = day + "/" + mon + "/" + yr;
                var timeFormatted = ("0" + now.getUTCHours()).slice(-2) + ":" + ("0" + now.getUTCMinutes()).slice(-2);
                var cur_time = fdate + " " + timeFormatted
                this.time_to_adj = "Adjusted 'Time To' to 15 minutes before current time (UTC) - current time is " + cur_time
            }

            if (timeTo < timeFrom) {
                this.time_from_adj = "Adjusted 'Time From' to 15 minutes before 'Time To' (UTC)"
                timeFrom = timeTo - 900
            }




            if (timeTo > timeFrom) {
                try {
                    var query = `mutation createRDDJob {
                        createRDDJob(rdd_usertype:"user",
                            rdd_start:"` + timeFrom + `",
                            rdd_finish:"` + timeTo + `",
                            rdd_filters: "` + JSON.stringify(filters).replace(/"/g, '\\"') + `", 
                            rdd_collectors:` + JSON.stringify(this.collector_selected) + `) {
                            status
                            error
                            errordesc
                            command
                            createResponse
                        }
                    }`;

                    console.log(query);
                    const res = await API.graphql(graphqlOperation(query));
                    console.log(res);


                    if (res.data.createRDDJob) {
                        if (res.data.createRDDJob.status == 'success' ) {
                            var msg = 'Job successfully created, see job status table below for results when ready'
                            this.create_msg = msg;
                            this.create_msg_col = 'success'
                            this.create_loading = false;
                            this.getStatus();
                        } else {
                            var msg = 'Error creating job: ' + res.data.createRDDJob.errordesc
                            this.create_msg = msg;
                            this.create_msg_col = 'red'
                            this.create_loading = false;
                        }
                    } else {
                        var msg = 'Error creating job: Failed to submit'
                        this.create_msg = msg;
                        this.create_msg_col = 'red'
                        this.create_loading = false;
                    }
                } catch (err) {
                    console.log(err)
                    var msg = 'Error creating job: ' + err
                    this.create_msg = msg;
                    this.create_msg_col = 'red'
                    this.create_loading = false;
                }
            } else {
                var msg = 'Error creating job: Please choose valid timeframe'
                this.create_msg = msg;
                this.create_msg_col = 'red'
                this.create_loading = false;
            }
            
            
        },
        timeRangeCalc: function (from, to) {
            
            var fromMin = (from.hour * 60) + (from.minute)
            var toMin = (to.hour *60) + (to.minute)
            var APIReturnBucketSize = 15;
            var timeRange = Math.ceil((toMin-fromMin)/APIReturnBucketSize)*APIReturnBucketSize
            if (timeRange > 300) {
                timeRange = 300
                return timeRange
            }
            return timeRange

        }
    },
    watch: {
        collector_selection: {
            deep: true,
            handler() {
                this.adjustSelected()
            }
        }
    }

}
</script>

<style scoped>
.tile {
  background: white;
}
.header-row {
    background-color: lightgrey !important;
    font-weight: bold;
}
.cursor-pointer {
  cursor: pointer;
}
</style>